import React from "react";
import { CircularProgress } from "@mui/material";

export default function CarregandoCustom() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        marginTop: "20%",
      }}
    >
      <CircularProgress color="primary" />
    </div>
  );
}
